import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export const Dashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  // Если пользователь не залогинен — редирект на логин
  useEffect(() => {
    if (user === null) return;
    if (!user) {
      navigate('/login');
    }
  }, [user, navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    logout();
    navigate('/login'); // сразу отправляем на логин
  };
  const handleHome = () => {
    navigate('/');
  };

  return (
    <div className='dashboard container'>
      <h1>Xush kelibsiz, {user?.username}!</h1>
      <div className="dashboard__links">
        <button onClick={handleLogout}>Chiqish</button>
        <button className='dashboard__home' onClick={handleHome}>Asosiy menyu</button>
      </div>
    </div>
  );
};
